import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Button from "@mui/material/Button";
import Rating from "@mui/material/Rating";

import courseImg from "./images/course.png";

export default function CourseCard({ course }) {
  const title = course.title;
  const subHeading = course.subheading;
  const description = course.description;
  const rating = course.rating;
  const reviews = course.reviews;

  const buttonStyle = {
    width: "80%",
    margin: "0 auto",
    display: "block",
  };

  return (
    <Card sx={{ maxWidth: 345 }}>
      <CardMedia
        component="img"
        height="194"
        src={courseImg}
        alt="Course profile"
      />

      <CardContent>
        <Typography variant="h6">{course.title}</Typography>
        <Typography variant="subtitle1">{course.subheading}</Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {course.description}
        </Typography>
        <div>
          {course.rating}
          <Rating
            name="half-rating-read"
            defaultValue={course.rating}
            precision={0.5}
            readOnly
          />
          ({course.reviews})
        </div>
      </CardContent>
      <CardActions disableSpacing>
        <Button style={buttonStyle} variant="outlined">
          Contained
        </Button>
      </CardActions>
    </Card>
  );
}
